import {
  FETCH_APP_CONFIG_REQUEST,
  FETCH_APP_CONFIG_SUCCESS,
  FETCH_APP_CONFIG_FAILURE,
} from "../action/appConfig";

const initialState = {
  footerLinks: [],
  isLoading: false,
  error: null,
};

export default function AppConfigReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_APP_CONFIG_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_APP_CONFIG_SUCCESS:
      return {
        ...state,
        footerLinks: action.payload.footerLinks || [],
        isLoading: false,
        error: null,
      };
    case FETCH_APP_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
